/**
 * Compact horizontal star distribution ("4× 5★, 1× 3★") for community-rated listings.
 * Shows only stars with at least one review, sorted 5→1. Renders as a subtle text row.
 */
export function CommunityRatingDistribution({ distribution, size = "sm" }) {
  if (!distribution || typeof distribution !== "object") return null;
  const entries = Object.entries(distribution)
    .map(([k, v]) => [parseInt(k, 10), parseInt(v, 10)])
    .filter(([s, n]) => s >= 1 && s <= 5 && n > 0)
    .sort((a, b) => b[0] - a[0]);
  if (entries.length === 0) return null;

  const totalReviews = entries.reduce((sum, [, n]) => sum + n, 0);
  const textSize = size === "md" ? "text-xs" : "text-[10px]";
  const barW = size === "md" ? "w-16" : "w-10";

  return (
    <div className="flex flex-wrap items-center gap-2 mt-1.5" data-testid="community-rating-distribution">
      {entries.map(([stars, count]) => {
        const pct = Math.round((count / totalReviews) * 100);
        return (
          <div key={stars} className="flex items-center gap-1.5" data-testid={`crd-row-${stars}`}>
            <span className={`font-body font-bold text-emerald-800 ${textSize}`}>{count}×</span>
            <div className="flex items-center gap-0.5">
              <span className={`font-body font-bold text-emerald-800 ${textSize}`}>{stars}</span>
              <span className={`text-amber-400 ${textSize}`}>★</span>
            </div>
            <div className={`h-1 ${barW} bg-emerald-100 rounded-full overflow-hidden`}>
              <div className="h-full bg-emerald-500 rounded-full" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
